/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const EpisodeSame: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="episode-same" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M890.0633333333334 753.27L623.3333333333333 486.5400000000001L469.9366666666666 639.9366666666666L550.0633333333333 720.0633333333333L623.3333333333333 646.7933333333333L809.9366666666666 833.3966666666668L890.0633333333333 753.2700000000001zM1020 1133.3333333333333A113.3333333333333 113.3333333333333 0 0 0 1133.3333333333333 1020V340A113.3333333333333 113.3333333333333 0 0 0 1020 226.6666666666668H226.6666666666667V1020A113.3333333333333 113.3333333333333 0 0 0 340 1133.3333333333333H1020zM340 340H1020V1020H340V340zM113.3333333333333 340H0V1020H113.3333333333333V340zM1360 340H1246.6666666666665V1020H1360V340z" : "M712.0506666666668 602.616L498.6666666666667 389.232L375.9493333333333 511.9493333333332L440.0506666666667 576.0506666666665L498.6666666666667 517.4346666666667L647.9493333333334 666.7173333333333L712.0506666666666 602.616zM816 906.6666666666666A90.6666666666667 90.6666666666667 0 0 0 906.6666666666669 816V272A90.6666666666667 90.6666666666667 0 0 0 816 181.3333333333333H181.3333333333334V816A90.6666666666667 90.6666666666667 0 0 0 272 906.6666666666666H816zM272 272H816V816H272V272zM90.6666666666667 272H0V816H90.6666666666667V272zM1088 272H997.3333333333334V816H1088V272z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
EpisodeSame.displayName = `Blueprint5.Icon.EpisodeSame`;
export default EpisodeSame;
